module.exports = __webpack_public_path__ + "prod/1.42.2/img/ykzx.935d8853.png";